const MarketerOnboardingTooltip = () => (
  <div className="tw-text-left tw-font-normal tw-leading-[16px] tw-text-[12px]">
    To send mail:
    <ul className="tw-m-0 tw-p-0 tw-pl-[14px]">
      <li>Personal onboarding must be complete in Marketer</li>
      <li>An admin or account owner needs to have completed team-level onboarding in Marketer</li>
    </ul>
    <div className="tw-pt-[16px]">
      You can find a link to Brivity Marketer in the main navigation on the left side of your screen.
    </div>
  </div>
);

export default MarketerOnboardingTooltip;
